// removed by extract-text-webpack-plugin
module.exports = {"listItem":"gNZTp","list":"_2Hrzv","stats":"_3zD21"};